import { StrategyEvent } from '../../types/strategy-entities';

export interface StrategyEventStateByStrategyId {
  loading: boolean;
  pending: boolean;
  loaded: boolean;
  error?: string;
  strategyEvents: StrategyEvent[];
}

export const initialStrategyEventStateByStrategyId: StrategyEventStateByStrategyId = {
  loading: false,
  pending: false,
  loaded: false,
  error: undefined,
  strategyEvents: []
};

export interface StrategyEventState {
  [strategyId: string]: StrategyEventStateByStrategyId;
}

export const initialStrategyEventState: StrategyEventState = {};
